<template>
  <div>
    <div class="floral-bg-image"></div>
    <div class="center-container has-margin-top has-width">
      <div class="contact-us__header">
        <h1>{{ contactUsTitle }}</h1>
        <p>{{ contactUsdescription }}</p>
      </div>
      <div class="contact-us-grid">
        <ContactUsForm></ContactUsForm>
        <ContactUsDetails></ContactUsDetails>
      </div>
    </div>
  </div>
</template>

<script>
import ContactUsForm from '@/components/ContactForm'
import ContactUsDetails from '@/components/ContactDetails'

export default {
  name: 'GetInTouch',
  data: () => ({
    contactUsTitle: 'Get In Touch',
    contactUsdescription: 'We are looking forwards to hearing from you! Send us an email with your wants and needs and let us help you get there.',
  }),
  components: {
    ContactUsForm,
    ContactUsDetails,
  },
  metaInfo: {
    title: 'Berries and Blooms - Contact Us',
    links: [
      { rel: 'canonical', href: 'http://berriesandblooms.co.za/get-in-touch' },
      { rel: 'alternate', href: 'http://berriesandblooms.co.za/get-in-touch', hreflang: 'en-us' },
    ],
  },
}
</script>
